
const BASE_URL = process.env.REACT_APP_BASE_URL
console.log(BASE_URL, "BASEURL")

const apiRoute = {
  // getSubscribed: BASE_URL+'user/getsubscriptions',
}

export { apiRoute }
